import versionConfig from '../config/version.json';

export interface VersionInfo {
  version: string;
  releaseDate: string;
  author: string;
}

export function useVersionInfo(): VersionInfo {
  return versionConfig;
}
